import React, {FC} from "react"
import {Card} from "@jane/lib/src/components/Card";
import {JaneEmployee, useEmployeesData} from "../resources/EmployeeContext";
import {faOctagonExclamation} from "@fortawesome/pro-solid-svg-icons";
import {Button} from "../../../lib/src/components/form/Button";
import {faWarning} from "@fortawesome/free-solid-svg-icons";
import {useApiCall} from "../../../lib/src/api";
import {config} from "../config";

export const EmployeeDestroyForm: FC<{employee: JaneEmployee&{sub:string|null}}> = (props) => {
  const [confirm, setConfirm] = React.useState(false)
  const {employees} = useApiCall(config)
  const {reload} = useEmployeesData()
  return <Card title={'Account uitschakelen'} icon={faOctagonExclamation} id={"destroy"}>
    {props.employee.sub === null ? <div className={'text-center py-8 font-medium text-brand-error'}>
      Voor deze medewerker bestaat nog geen gebruikersaccount, deze kan dus ook niet uitgeschakeld worden.
    </div> : <div>
      <label className={`flex space-x-2 hover:cursor-pointer border border-brand-on-primary-container border-opacity-25 ${confirm ? 'bg-brand-on-primary-container bg-opacity-5' : ''} rounded-lg p-2 mb-4`}>
        <input className={'mx-2'} type="checkbox" onChange={(e) => setConfirm(e.target.checked)} checked={confirm}/>
        <div className={''}>
          <h1 className={'font-medium mb-1'}>Account volledig uitschakelen</h1>
          <p className={'text-sm'}>Hierdoor kan de gebruiker <strong>{props.employee.preferred_username}</strong> niet meer inloggen.</p>
          <p className={'text-sm'}>Deze actie is <strong>niet</strong> ongedaan te maken, gebruik bij uitzondering.</p>
        </div>
      </label>
      <Button type={'primary'} size={'sm'} icon={faWarning} text={'Account permanent uitschakelen'} disabled={!confirm} onClick={async () => {
        if (window.confirm('Weet je zeker dat je deze gebruiker wilt verwijderen')) {
          await employees.destroyEmployee(props.employee.sub)
          reload()
        }
      }} />
    </div>}
  </Card>
}
